import Store from "@/store";
import toasterTypes from "@/toaster/ToasterTypes";

export const $notify = {
  success(message, handler = undefined) {
    Store.commit("toaster/SET_MESSAGE", {
      message,
      type: toasterTypes.SUCCESS,
      handler: handler,
    });
  },
  error(message) {
    Store.commit("toaster/SET_MESSAGE", {
      message,
      type: toasterTypes.ERROR,
    });
  },
  apiError(e) {
    Store.commit("toaster/SET_MESSAGE", {
      message:
        e?.response?.data?.errors?.message?.[0] ?? e?.response?.data?.message,
      type: toasterTypes.ERROR,
    });
  },
};

export default function (vue) {
  vue.prototype.$notify = $notify;
}
